var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PickUp-White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PickUp-White",
    clipPath: "url(#clip-PickUp-White)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(-0.369 0.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M9.621,29.107v2.275H16.8V29.1a.56.56,0,0,1,.163-.389l1.066-1.066a6.8,6.8,0,0,0,2.019-4.879V14.328a.952.952,0,0,0-.872-.963.962.962,0,0,0-1.045.86v2.522a.554.554,0,0,1-.553.564h-.011A.568.568,0,0,1,17,16.747l.01-4.007a.946.946,0,0,0-.871-.964.957.957,0,0,0-1.045.861v4.11a.563.563,0,0,1-.564.564.569.569,0,0,1-.564-.564V12.74c0-.052.01-.093.01-.144V11.3a.958.958,0,1,0-1.916,0v5.443a.564.564,0,1,1-1.128,0v-4.11a.96.96,0,0,0-1.916.1v7.809a.785.785,0,0,1-1.548.184l-.41-1.671a.988.988,0,0,0-1.137-.748.034.034,0,0,1-.02.011.989.989,0,0,0-.779,1.158l.8,4.038a6.8,6.8,0,0,0,1.9,3.546l1.64,1.64A.566.566,0,0,1,9.621,29.107Z",
    transform: "translate(0 -0.062)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(13.906 3.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(11.954 26.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M26.984,30.844a.548.548,0,1,0,.16.387A.546.546,0,0,0,26.984,30.844Z",
    transform: "translate(-26.052 -30.684)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M31.334,12.706a2.135,2.135,0,0,0-1.4-.9,2.16,2.16,0,0,0-2.273,1.1V7.134a2.119,2.119,0,0,0-3.174-1.84,2.121,2.121,0,0,0-4.182,0,2.118,2.118,0,0,0-3.164,1.633,2.12,2.12,0,0,0-3.154,1.852.547.547,0,0,0,1.094,0,1.027,1.027,0,0,1,2.048-.106v1.455a.547.547,0,0,0,1.095,0v-3a1.027,1.027,0,0,1,2.048-.106v4.262c0,.025.006.207.006.207a.547.547,0,0,0,1.094,0V7.134a1.186,1.186,0,0,0-.006-.147V5.646a1.027,1.027,0,1,1,2.054,0V6.987c0,.049-.006.1-.006.147v7.694a.547.547,0,0,0,1.094,0l.006-7.8a1.028,1.028,0,0,1,2.049.106v8.1a.779.779,0,0,0,1.535.184l.426-1.736a1.062,1.062,0,0,1,2.074.456l-.823,4.178A7.139,7.139,0,0,1,27.8,22l-1.7,1.7a.544.544,0,0,0-.161.386v4.874a.547.547,0,0,0,1.094,0V24.307l1.542-1.536a8.229,8.229,0,0,0,2.271-4.251l.823-4.178A2.133,2.133,0,0,0,31.334,12.706Z",
    transform: "translate(-13.987 -3.527)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(8.298 4.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M12.105,7.017,9.247,4.16a.542.542,0,0,0-.767.766l2.858,2.858a.542.542,0,0,0,.778-.755Z",
    transform: "translate(-8.328 -4.006)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(8.294 8.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M10.188,8.511H8.865a.542.542,0,1,0,0,1.084h1.323a.542.542,0,1,0,0-1.084Z",
    transform: "translate(-8.323 -8.511)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(12.736 3.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M13.349,4a.542.542,0,0,0-.542.542V5.908a.542.542,0,0,0,1.084,0V4.542A.542.542,0,0,0,13.349,4Z",
    transform: "translate(-12.807 -4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupWhite);
export default __webpack_public_path__ + "static/media/Pickup-White.b72ace17986a6ecb777c4576b9f5daef.svg";
export { ForwardRef as ReactComponent };